import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { fadeUp, viewportOnce } from "../lib/motion";

const BENEFITS = [
    "Understand your plans before you commit to them.",
    "See the cost story behind your design choices.",
    "Compare contractor quotations with confidence.",
];

const HomeIntroducing = () => (
    <section
        data-testid="home-introducing-section"
        className="relative bg-ink py-24 lg:py-32"
    >
        <div className="mx-auto grid max-w-[1600px] items-center gap-14 px-6 md:px-10 lg:grid-cols-12 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="lg:col-span-6"
            >
                <p className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist">
                    <span className="h-1.5 w-1.5 bg-accent" />
                    INTRODUCING BUILDEASE
                </p>
                <h2
                    data-testid="introducing-headline"
                    className="mt-8 font-display text-4xl font-semibold leading-[1.1] text-white md:text-6xl"
                >
                    Greater clarity across your home-building journey
                    <span className="text-accent">.</span>
                </h2>
            </motion.div>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="lg:col-span-6"
            >
                <p className="max-w-xl text-[16px] leading-relaxed text-mist">
                    BuildEase brings construction information, cost
                    intelligence and decision-support together in one
                    connected platform — built for South African homes under
                    500 m², and for the people building them.
                </p>
                <ul className="mt-8 space-y-4">
                    {BENEFITS.map((b, i) => (
                        <li
                            key={b}
                            data-testid={`introducing-benefit-${i + 1}`}
                            className="flex items-start gap-3 text-[16px] leading-relaxed text-white/90"
                        >
                            <span className="mt-2.5 h-1.5 w-1.5 shrink-0 bg-accent" />
                            {b}
                        </li>
                    ))}
                </ul>
                <Link
                    to="/product"
                    data-testid="introducing-platform-link"
                    className="group mt-10 inline-flex items-center gap-2 text-[15px] font-semibold text-accent transition-colors duration-300 hover:text-[#ff7026]"
                >
                    Explore the platform
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                </Link>
            </motion.div>
        </div>
    </section>
);

export default HomeIntroducing;
